// removed by extract-text-webpack-plugin
module.exports = {"HomeService":"_2iG9plTW57sJ11tj62Z0if","header":"_1KaCZztx9oUzd3KcxWjqI2","borderHighlight":"_1JTa_2MNZgPnHn1YdIeV1n","title":"_1AxYyapPP5d61EgUF3TQ0w","listVoucher":"_3tvjfh1R9geI6IvLnIxN3H","collectionRow":"_15JAllTUhXyrsOkQ4sT-1k","collectionCard":"_1ewrAxSNiFQGu9EpSO9fXO","modalAlert":"_2hNCHATPAmrxbMFlj0J3nn","headerAlert":"_1G6hLtvlnEUcGP4jCaUhCK","contentAlert":"_1DMr397Gmb9LhKVF8WQCT7","btnLogin":"_3CNe0G-sP0t8Mh4Gg8Tw9c"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomeService/HomeService.scss
// module id = 1172
// module chunks = 0